export default __webpack_public_path__ + "static/media/aqua5.d9ccc6ae.png";